<script>

    import { status } from "./status.js";
    import { addService, changeService } from "./apihandler.js"
    import page from "page";
    import { fancyAlert, fancyConfirm, fancyMessage } from "./notification.js"
    import { deleteUser, deleteService, getUsers, checkAdminToken, hookTest } from "./apihandler.js"
    import { tl } from "./multilang.js";
    import { slide, fade } from 'svelte/transition';
    import { onMount } from "svelte";

    import {copyTextToClipboard} from "./copyTextToClipboard.js";

    onMount(() => {
        $status.notification.show = false;
        $status.notification.confirm = false;
    });

    function switchToUsers(index) {
        configureServiceModalFlag = false;    
        $status.params = $status.subscription.services[index].name;
        page("/users");
    }

    // Service Creation
    function createServiceModal() {

        newService.duress = false;
        newService.service = "";
        newService.window = 600;
        createServiceModalFlag = true;
        refreshTokenStatus();
        
    }

    function refreshTokenStatus() {
        isAdminTokenOpen = true;
        checkAdminToken($status.subscription.id, $status.subscription.sessionAuth)
        .then(() => {
            isAdminTokenOpen = true;
        })
        .catch(async (error) => {
            if (error == 490) {

                isAdminTokenOpen = false;
            }
            else {
                await fancyAlert(error, tl("Error"));
            }
            
        });

    }

    async function createService() {

        let id = $status.subscription.id;
        let code = $status.subscription.sessionAuth;
        let service = newService.service;
        let window = +(newService.window);
        let duress = newService.duress;

        addService(id, code, service, window, duress)
            .then((newServiceContent) => {
                $status.subscription.services.push(newServiceContent);
                $status = $status;
                createServiceModalFlag = false;
            })
            .catch(async (error) => {
                if (error == 403) {
                    createServiceModalFlag = false;
                    await fancyAlert(tl("Your session expired, please log in again"), tl("Session expired"));
                    page("/login");
                    $status.loggedIn = false;
                    $status.subscription = {};
                }
                else if (error == 490) {
                    await fancyAlert(tl("Please open you administrative token in the ZofToken app and retry when ready"), tl("Open your token"));
                }
                else {
                    await fancyAlert(error, tl("Error"));
                }
            });

    }

    // Service Removal

    async function removeServiceConfirmation(index) {

        let id = $status.subscription.id;
        let code = $status.subscription.sessionAuth;

        getUsers(id, code)
            .then(async (userData) => {
                $status.subscription.currentUsers = userData.currentUsers;
                $status.subscription.users = userData.users;

                let service = $status.subscription.services[index].name;

                if ($status.subscription.users.find((item) => item.service == service)) {
                    if (await fancyConfirm(tl("The service has active users, do you want to delete all users as well?"), tl("Delete service"), tl("Delete service"))) {

                        let usersToDelete = $status.subscription.users.filter((i) => i.service == service);
                        let authKey = $status.subscription.services[index].adminAuthKey;

                        for (let i = 0; i < usersToDelete.length; i++) {
                            try {
                                let userId = usersToDelete[i].user;
                                let userService = `${$status.subscription.id}_${usersToDelete[i].service}`;

                                await deleteUser(userId, userService, authKey);

                                $status.subscription.users.splice($status.subscription.users.findIndex((user) => user.user == usersToDelete[i].user && user.service == usersToDelete[i].service), 1);
                                $status.subscription.currentUsers--;
                            }
                            catch (error) {
                                await fancyAlert(error, tl("Error"));
                            }
                        }
                        removeService(index);
                    }
                }
                else if (await fancyConfirm(tl("Are you sure you want to delete the service?"), tl("Delete service"), tl("Delete service"))) {
                    removeService(index)
                }
            })
            .catch(async (error) => {
                if (error == 403) {
                    await fancyAlert(tl("Your session expired, please log in again"), tl("Session expired"));
                    page("/login");
                    $status.loggedIn = false;
                    $status.subscription = {};
                }
                else {
                    await fancyAlert(error, tl("Error"));
                }
            });
    }

    async function removeService(index) {

        let id = $status.subscription.id;
        let code = $status.subscription.sessionAuth;
        let service = $status.subscription.services[index].name;

        deleteService(id, code, service)
            .then(() => {
                $status.subscription.services.splice(index, 1);
                $status = $status;
            })
            .catch(async (error) => {
                if (error == 403) {
                    await fancyAlert(tl("Your session expired, please log in again"), tl("Session expired"));
                    page("/login");
                    $status.loggedIn = false;
                    $status.subscription = {};
                }
                else if (error == 490) {
                    await fancyAlert(tl("Please open you administrative token in the ZofToken app and retry when ready"), tl("Open your token"));
                }
                else {
                    await fancyAlert(error, tl("Error"));
                }
            });
    }

    // Service Configuration

    function configureServiceModal(index) {
        serviceIndex = index;
        configureServiceModalFlag = true;
        refreshTokenStatus();

        // checkAdminToken($status.subscription.id, $status.subscription.sessionAuth)
        // .then(() => {
        //     configureServiceModalFlag = true;
        // })
        // .catch(async (error) => {
        //     if (error == 490) {
        //         await fancyAlert(tl("Be aware that your administrative ZofToken is currently closed and will need to be open to change anything in the service"));
        //         configureServiceModalFlag = true;
        //     }
        //     else {
        //         await fancyAlert(error, tl("Error"));
        //     }
            
        // });

        
    }

    function configureService() {

        let id = $status.subscription.id;
        let code = $status.subscription.sessionAuth;
        let service = $status.subscription.services[serviceIndex].name;
        let window = +($status.subscription.services[serviceIndex].window);
        let hook = $status.subscription.services[serviceIndex].hook;
        let details = $status.subscription.services[serviceIndex].details;

        changeService(id, code, service, window, hook, details)
            .then(() => {
                configureServiceModalFlag = false;
                fancyMessage(tl("Service saved"));
            })
            .catch(async (error) => {
                if (error == 403) {
                    configureServiceModalFlag = false;
                    await fancyAlert(tl("Your session expired, please log in again"), tl("Session expired"));
                    page("/login");
                    $status.loggedIn = false;
                    $status.subscription = {};
                }
                else if (error == 490) {
                    await fancyAlert(tl("Please open you administrative token in the ZofToken app and retry when ready"), tl("Open your token"));
                }
                else {
                    await fancyAlert(error, tl("Error"));
                }
            });
    }

    // Webhook Testing

    async function requestWebhookTest() {

        let id = $status.subscription.id;
        let code = $status.subscription.sessionAuth;
        let hook = $status.subscription.services[serviceIndex].hook;

        hookTestLoader = true;

        hookTest(id, code, hook)
            .then(async (testResults) => {
                hookTestLoader = false;

                if (testResults.error) {
                    if (testResults.error == "TIMEOUT") {
                        await fancyAlert(tl("Possible port error or firewalling issues?"), tl("Connection timed out"));
                    }
                    else {
                        await fancyAlert(`${testResults.error}`, tl("Error connecting"));
                    }
                }
                else {
                    await fancyAlert(`${tl("Body returned:")} ${testResults.body}`,`${tl("Status code:")} ${testResults.status}`, tl("OK"), "NORMAL")
                }
            })
            .catch(async (error) => {
                if (error == 403) {
                    await fancyAlert(tl("Your session expired, please log in again"), tl("Session expired"));
                    page("/login");
                    $status.loggedIn = false;
                    $status.subscription = {};
                }
                else {
                    await fancyAlert(error, tl("Error"));
                }
            });
    }

  function copyToClipboard(text) {

    if (copyTextToClipboard(text)) {
      fancyMessage(tl("Copy succesful")) 
    }
  }

function encodeImageFileAsURL() {
  var file = files[0];
  if (file.type == 'image/png' && file.size < 100000) {
    var reader = new FileReader();
    reader.onloadend = function() {
        $status.subscription.services[serviceIndex].details.logo = reader.result.substring(22);
    }
    reader.readAsDataURL(file);
  }
  else {
      fancyAlert(tl("Image file format must be PNG, and file size less than 100KB"), tl("Invalid file format"));
      files = null;
  }

}


    // Component variables

    let createServiceModalFlag = false;
    let configureServiceModalFlag = false;
    let newService = {
        service: "",
        window: 60,
        duress: false
    };
    let serviceIndex = 0;
    let filter;
    let hookTestLoader = false;
    let files;
    let importedImage;
    
    let isAdminTokenOpen = false;

    let serviceEditAboutFlag, serviceEditConfigFlag, serviceEditParametersFlag = false;


</script>


<style>

h4 {
    padding-right: 1rem;
}

.help-with-padding-left{
    padding-left: 1.6rem;
}

.tag:not(body).is-warning.is-light,
.tag:not(body).is-danger.is-light {
    white-space: inherit;
    height: inherit;
    padding: 1rem 1.2rem;
    margin-bottom: 2rem;
}

.file.is-dark .file-cta {
  background-color: hsl(210, 24%, 24%);
}

.is-width-80{
  width: 80%;
}

@media screen and (max-width: 1215px){
    .level-block{
        display: block;
    }
    .level-block .level-item{
        margin-bottom: 1.2rem;
    }
    .zt-field-wrapper p.is-too-long{
        width: 75%;
    }
}
</style>

<svelte:head>
  <title>ZaaS - {tl("My services")}</title>
</svelte:head>


<section class=" has-background-grey-lightest	">
    <div class="container">


        <div class="columns is-centered">
            <div class="column">

                <div class="level">
                    <div class="level-left">
                        <div class="level-item is-baseline">
                            <h4 class="is-size-4">{tl("My services")}</h4>
                            <span class="is-size-7">
                                {tl("Your subscription has")}
                                <strong>{$status.subscription.currentUsers}</strong>
                                {$status.subscription.maxUsers ? `/ ${$status.subscription.maxUsers}` : ""} {tl("users")}
                            </span>
                        </div>
                    </div>

                    <div class="level-right">

                        <div class="level-item">

                            <div class="field">
                                <div class="control has-icons-right">
                                    <input class="input" type="text" bind:value={filter}
                                        placeholder={tl("Search for a service")} on:click={()=> filter = ""}>
                                    <span class="icon is-small is-right">
                                        <ion-icon name="{filter ? 'close-circle-outline' : 'search-outline'}">
                                        </ion-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="level-item">
                            <button class="button  is-dark" on:click={createServiceModal}>{tl("New service")}</button>
                        </div>

                    </div>
                </div>



                {#each $status.subscription.services.filter((i) => !filter || i.name.toLowerCase().includes(filter.toLowerCase())) as service}
            <div class="box is-outlined">
                <div class="columns">
                    <div class="column is-2">
                        <div class="zt-field-wrapper">
                            <label>{tl("Service")}</label>
                            <p><span class="has-text-weight-light">{$status.subscription.id}_</span><span class="has-text-weight-bold">{service.name}</span></p>
                        </div>
                    </div>

                    <div class="column is-2">

                    <div class="zt-field-wrapper">
                        <label class="zt-label">{tl("Service")}</label>
                        <p>{service.name}</p>
                    </div>

                    <div class="zt-field-wrapper">
                        <label class="zt-label">{tl("users")}</label>
                        <p>{$status.subscription.users.filter((i) => i.service == service.name).length} <a on:click={() => switchToUsers($status.subscription.services.findIndex(s => s.name == service.name))} class="is-size-9">{tl("VIEW")}</a></p>
                    </div>

                    </div>

                    <div class="column is-2">
                        <div class="zt-field-wrapper">
                            <label class="zt-label">{tl("Token active duration")}</label>
                            <p>{service.window}</p>
                        </div>

                        <div class="zt-field-wrapper">
                            <label class="zt-label">{tl("Duress function")}</label>
                            <p>{service.duress ? tl("Enabled") : tl("Disabled")}</p>
                        </div>
                    </div>
                
                    <div class="column is-3">
                        <div class="zt-field-wrapper">
                            <label class="zt-label">{tl("Basic Auth")}</label>
                            <p class="is-too-long">{service.basicAuthKey} <a class="button-copy is-small" on:click={() => copyToClipboard(service.basicAuthKey)} >{tl("Copy")}</a></p>
                        </div>

                        <div class="zt-field-wrapper">
                            <label class="zt-label">{tl("Admin Auth")}</label>
                            <p class="is-too-long">{service.adminAuthKey} <a class="button-copy is-small"  on:click={() => copyToClipboard(service.adminAuthKey)}>{tl("Copy")}</a></p>
                        </div>
                    </div>

                    <div class="column is-3 is-vbottom">
                        <div class="level level-block">
                            <div class="level-item has-text-centered">
                                <a class="has-text-danger" on:click={() => removeServiceConfirmation($status.subscription.services.findIndex(s => s.name == service.name))}>{tl("Delete service")}</a> 
                            </div>
                            <div class="level-item has-text-centered">
                                <button class="button is-small" on:click={() => configureServiceModal($status.subscription.services.findIndex(s => s.name == service.name))}>{tl("View/Edit details")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>
</div>

{#if createServiceModalFlag}
<div class="modal is-active is-fixed-right">
	<div class="modal-background">
	</div>

	<div class="modal-content" transition:fade="{{ duration: 200 }}">
        <div class="card">
            <div class="card-heading">
                <div class="level">
                    <div class="level-left">
                        <div class="level-item has-text-weight-semibold">
                            {tl("Create new service")}
                        </div>
                    </div>
                    
                    <div class="level-right">
                        <div class="level-item">
                            <button class="delete is-large" on:click={() => {createServiceModalFlag = false}}></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-content is-clearfix">

            {#if !isAdminTokenOpen}
            <div class="columns is-vcentered" transition:fade="{{ duration: 200 }}">
                <div class="column">
                    <span class="tag is-danger is-light ">{tl("Be aware that your administrative ZofToken is currently closed and will need to be open to create a new service")}</span>
                </div>
                <div class="column is-1">
                        <span class="icon is-large is-clickable is-size-1 has-text-danger" on:click={() => refreshTokenStatus()}>
                            <ion-icon name="refresh-circle"></ion-icon>
                        </span>
                </div>
            </div>
            {/if}

                <div class="zt-field-wrapper">
                    <label class="zt-label">{tl("Service")}</label>
                    <div class="control">
                        <input class="input" type="text" bind:value={newService.service} placeholder={tl("Service")}>
                    </div>
                    <p class="help">{tl("All service names will use the subscription name as a prefix to ensure uniqueness.")}</p>
                    <p class="help has-text-danger" class:is-invisible={!$status.subscription.services.find(i => i.name == newService.service)}>{tl("Duplicate service name")}</p>
                </div>
                <div class="field">
                    
                </div>

                <div class="zt-field-wrapper">
                    <label class="zt-label">{tl("Token active duration")}</label>
                    <div class="control">
                        <input class="input" type="text" bind:value={newService.window} placeholder={tl("Service")}>
                    </div>
                    <p class="help">{tl("How long (in seconds) the token remains active after the user opens it.")}</p>
                </div>
            
                <div class="zt-field-wrapper has-background-danger">
                    <label class="zt-label"> </label>
                    <div class="control">
                        <label class="checkbox">
                            <input type="checkbox" bind:checked={newService.duress}> 
                            {tl("Enable duress function")}
                        </label>
                    </div>
                    <p class="help">{tl("This selection can not be changed after creation.")}</p>
                </div>
            </div>
            
            <footer class="card-footer"> 
                <p class="card-footer-item ">
                    <button class="button is-dark " disabled={newService.service.trim().length == 0 || $status.subscription.services.find(i => i.name == newService.service)} on:click={createService}>Create service</button>
                </p>
                <p class="card-footer-item">
                    <button class="button " on:click={() => {createServiceModalFlag = false}}>{tl("Cancel")}</button>
                </p>
            </footer>
        </div>
	</div>
</div>
{/if}

{#if configureServiceModalFlag}
<div class="modal is-active is-fixed-right">
	<div class="modal-background">
	</div>

    <div class="modal-content" transition:fade="{{ duration: 200 }}">
        <div class="card">
            <div class="card-heading">
                <div class="level">
                    <div class="level-left">
                        <div class="level-item has-text-weight-semibold">
                            {$status.subscription.services[serviceIndex].name}
                        </div>
                    </div>
                    
                    <div class="level-right">
                        <div class="level-item">
                            <button class="delete is-large" on:click={() => {configureServiceModalFlag = false}}></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-content is-clearfix">

                {#if !isAdminTokenOpen}
                    <div class="columns is-vcentered" transition:fade="{{ duration: 200 }}">
                        <div class="column">
                            <span class="tag is-danger is-light ">{tl("Be aware that your administrative ZofToken is currently closed and will need to be open to change anything in the service")}</span>
                        </div>
                        <div class="column is-1">
                                <span class="icon is-large is-clickable is-size-1 has-text-danger" on:click={() => refreshTokenStatus()}>
                                    <ion-icon name="refresh-circle"></ion-icon>
                                </span>
                        </div>
                    </div>
                {/if}

                <!-- collapsible cards -->

                <!-- About this service -->
                <div class="card">
                    <header class="card-header is-clickable" on:click={() => {serviceEditAboutFlag = !serviceEditAboutFlag}}>
                        <p class="card-header-title">{tl("About this service")}</p>
                        <a href="#" class="card-header-icon" aria-label="About this service">
                        <span class="icon">
                            <ion-icon name={serviceEditAboutFlag ? 'chevron-down-outline' : 'chevron-forward-outline'}></ion-icon>
                        </span>
                        </a>
                    </header>
                    <div class="card-content" class:is-hidden={!serviceEditAboutFlag}>
                        <div class="content">
                                <div class="zt-field-wrapper">
                                    <label class="zt-label">{tl("Service")}</label>
                                    <p>{$status.subscription.services[serviceIndex].name}</p>
                                </div>

                                <div class="zt-field-wrapper">
                                    <label class="zt-label">{tl("Users")}</label>
                                    <p>{$status.subscription.users.filter((i) => i.service == $status.subscription.services[serviceIndex].name).length} &nbsp;<a on:click={() => switchToUsers(serviceIndex)} class="is-size-9">{tl("VIEW")}</a></p>
                                </div>

                                <div class="zt-field-wrapper">
                                    <label class="zt-label">{tl("Token active duration")}</label>
                                    <p>{$status.subscription.services[serviceIndex].window}</p>
                                </div>

                                <div class="zt-field-wrapper">
                                    <label class="zt-label">{tl("Duress function")}</label>
                                    <p>{$status.subscription.services[serviceIndex].duress ? "Enabled" : "Disabled"}</p>
                                </div>

                                <div class="zt-field-wrapper">
                                    <label class="zt-label">{tl("Basic Auth")}</label>
                                    <p class="is-width-86">{$status.subscription.services[serviceIndex].basicAuthKey}<a class="button-copy is-small"  on:click={() => copyToClipboard($status.subscription.services[serviceIndex].basicAuthKey)} >{tl("Copy")}</a>
                                </div>

                                <div class="zt-field-wrapper">
                                    <label class="zt-label">{tl("Admin Auth")}</label>
                                    <p class="is-width-86">{$status.subscription.services[serviceIndex].adminAuthKey}<a class="button-copy is-small" on:click={() => copyToClipboard($status.subscription.services[serviceIndex].adminAuthKey)} >{tl("Copy")}</a></p>
                                </div>

            
                        </div>
                    </div>
                </div>

                <!-- Configuration -->
                <div class="card">
                    <header class="card-header is-clickable" on:click={() => {serviceEditConfigFlag = !serviceEditConfigFlag}}>
                        <p class="card-header-title">
                        {tl("Configuration")}
                        </p>
                        <a href="#" class="card-header-icon" aria-label="Configuration">
                        <span class="icon">
                            <ion-icon name={serviceEditConfigFlag ? 'chevron-down-outline' : 'chevron-forward-outline'}></ion-icon>
                        </span>
                        </a>
                    </header>
                    <div class="card-content" class:is-hidden={!serviceEditConfigFlag}>
                        <div class="content">

                            <div class="zt-field-wrapper">
                                                            <label class="zt-label">{tl("Logo")}</label>

                            {#if $status.subscription.services[serviceIndex].details.logo}
                            <figure class="image is-64x64 is-horizonal-center">
                            <img class="is-rounded" src="data:image/png;base64,{$status.subscription.services[serviceIndex].details.logo}">
                            </figure>
                            {/if}


                <div class="field is-grouped">

                    <div class="file has-name is-fullwidth is-width-80 control is-expanded is-dark">
                        <label class="file-label">
                            <input class="file-input" type="file" name="resume"  bind:files>
                            <span class="file-cta">
                            <span class="file-icon">
                                <ion-icon name="cloud-upload-outline"></ion-icon>
                            </span>
                            <span class="file-label">
                                {tl("Choose a file…")}
                            </span>
                            </span>
                            <span class="file-name extend" >
                                {files ? files[0].name : ''}
                            </span>
                        </label>
                    </div>



                    <div class="control">

                        <button class="button is-dark" on:click={() => {encodeImageFileAsURL()}} disabled={!(files && files[0])}>{tl("Import")}</button>
                    </div>

                </div>
                <p class="help">{tl("Image file format must be PNG, and file size less than 100KB")}</p>

                </div>

                            <div class="zt-field-wrapper">
                                <label class="zt-label">{tl("Service")}</label>
                                <div class="control">
                                    <input class="input" type="text" bind:value={$status.subscription.services[serviceIndex].details.friendly_name} placeholder={tl("Name")}>
                                </div>
                                <p class="help">{tl("Friendly name to show the user so they can identify the service.")}</p>
                            </div>
                            
                            <div class="zt-field-wrapper">
                                <label class="zt-label">{tl("Service description")}</label>
                                <div class="control">
                                    <input class="input" type="text" bind:value={$status.subscription.services[serviceIndex].details.service_description} placeholder={tl("Service description")}>
                                </div>
                                <p class="help">{tl("A short description to show the user regarding the service")}</p>
                            </div>

                            <div class="zt-field-wrapper">
                                <label class="zt-label">{tl("Contact information for errors")}</label>
                                <div class="control">
                                    <input class="input" type="text" bind:value={$status.subscription.services[serviceIndex].details.error_contact} placeholder={tl("Contact information for errors")}>
                                </div>
                                <p class="help">{tl("A short message to let the user know how they can access help (for example, dialing a telephone number) in case they have issues with their ZofToken.")}</p>
                            </div>

                            <div class="zt-field-wrapper">
                                <label class="zt-label">{tl("Offline mode description")}</label>
                                <div class="control">
                                    <input class="input" type="text" bind:value={$status.subscription.services[serviceIndex].details.offline_description} placeholder={tl("Offline mode description")}>
                                </div>
                                <p class="help">{tl("A short message to let the user know how they should proceed (for example, dialing a telephone number) in case they need to authenticate through Offline Mode.")}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Parameters -->
                <div class="card last-child">
                    <header class="card-header is-clickable" on:click={() => {serviceEditParametersFlag = !serviceEditParametersFlag}}>
                        <p class="card-header-title">
                        {tl("Parameters")}
                        </p>
                        <a href="#" class="card-header-icon" aria-label="Parameters">
                        <span class="icon">
                            <!-- <ion-icon name="chevron-down-outline"></ion-icon> -->
                            <ion-icon name={serviceEditParametersFlag ? 'chevron-down-outline' : 'chevron-forward-outline'}></ion-icon>
                        </span>
                        </a>
                    </header>
                    <div class="card-content" class:is-hidden={!serviceEditParametersFlag}>
                        <div class="content">
                            <!-- content here --> 
                            
                            <div class="zt-field-wrapper">
                                <label class="zt-label">{tl("Token active duration")}</label>
                                <div class="control">
                                    <input class="input" type="text" bind:value={$status.subscription.services[serviceIndex].window} placeholder={tl("Token active duration")}>
                                </div>
                                <p class="help">{tl("How long (in seconds) the token remains active after the user opens it.")}</p>
                            </div>

                            

                            <div class="is-divider"></div>

                            <div class="zt-field-wrapper">
                                <label class="zt-label">{tl("Webhook host name")}</label>
                                <div class="control">
                                    <input class="input" type="text" bind:value={$status.subscription.services[serviceIndex].hook.url} placeholder={tl("Webhook host name")}>
                                </div>
                                <p class="help">{tl("Needs to be a host name with an optional port that can be accessed through HTTPS.")}</p>
                            </div>

                            <div class="zt-field-wrapper">
                                <label class="zt-label">{tl("Webhook secret")}</label>
                                <div class="control">
                                    <input class="input" type="text" bind:value={$status.subscription.services[serviceIndex].hook.secret} placeholder={tl("Webhook secret")}>
                                </div>
                                <p class="help">{tl("This secret will be passed along in the webhook to verify it actually comes from the ZofToken server.")}</p>
                            </div>

                            <div class="zt-field-wrapper">
                                <div class="control">
                                    <label class="checkbox">
                                        <input type="checkbox" bind:checked={$status.subscription.services[serviceIndex].hook.checkCertificate}>
                                            {tl("Check the host certificate during the HTTPS connection")}
                                    </label>
                                </div>
                                <p class="help help-with-padding-left">{tl("Should be turned off if you are using a self-signed or otherwise invalid certificate when receiving the webhook.")}</p>
                            </div>

                            <div class="field">
                                <div class="control">
                                    <button class="button is-small" disabled={!$status.subscription.services[serviceIndex].hook.url} class:is-loading={hookTestLoader} on:click={requestWebhookTest}>{tl("Test webhook")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <a on:click={() => removeServiceConfirmation(serviceIndex)} class="has-text-danger	">{tl("Delete service")}</a>  

            </div>

            <footer class="card-footer">
            <p class="card-footer-item">
                <button class="button is-dark is-larger" on:click={configureService}>{tl("Save changes")}</button>
            </p>
            <p class="card-footer-item">
                <button class="button" on:click={() => {configureServiceModalFlag = false}}>{tl("Cancel")}</button>
            </p>
                
               

            </footer>
        </div>
	</div>
</div>
{/if}

</div>
</section>